import { KycKybPage } from '@/features/kyc/components/KycKybPage';

export default function KycKyb() {
  return <KycKybPage />;
}
